import { Component } from '@angular/core';

@Component({
  selector: 'lib-text-input',
  standalone: true,
  imports: [],
  templateUrl: './text-input.component.html',
  styleUrl: './text-input.component.css'
})
export class TextInputComponent {

}
